import * as angular from 'angular';
import { HttpService } from '../../../../app.common/modules/api/http.service';
import { BlobService } from '../../../../app.common/modules/common/services/blob.service';
import { RetailerService } from '../../api/retailer.service';
import { IPagingResult } from '../../model/IPagingResult.model';
import {
    IServiceEditModel,
    IServiceFetchFilter,
    IServiceModelListItem,
    IServicesModel
} from '../../model/services/IServicesModel';

export class ServicesService {
    public static $inject = ['http', 'retailerService', 'blobService'];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService,
        private blobService: BlobService
    ) { }

    public getServices(filter: IServiceFetchFilter) {
        return this.http.get<IPagingResult<IServiceModelListItem>>(this.retailerService.getServices(), {params: filter});
    }

    public getService(id: string) {
        return this.http.get<IServicesModel>(this.retailerService.getService(id));
    }

    public archiveService(id: string) {
        return this.http.put(this.retailerService.archiveService(id), null);
    }

    public restoreService(id: string) {
        return this.http.put(this.retailerService.restoreService(id), null);
    }

    public saveService(item: IServiceEditModel, id?: string) {
        if (!id) {
            return this.http.post<IServiceEditModel>(
                this.retailerService.createService(),
                item
            );
        } else {
            return this.http.put<IServiceEditModel>(
                this.retailerService.getService(id),
                item
            );
        }
    }

    public uploadServiceImage = (dataUri: string): angular.IPromise<string> => {
        const fd = new FormData();
        fd.append('FileImage', this.blobService.dataUriToBlob(dataUri));
        return this.http.post<string>(this.retailerService.uploadServiceImage(), fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    }
}

angular
    .module('naut')
    .service('servicesService', ServicesService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/common/services/services.service.ts